import React, { useEffect, useState, useRef } from "react"
import { Link } from "react-router-dom";
import { connect, useSelector } from "react-redux";
import { activateAccount } from "../../../actions/auth";
import Modal from "../../common/Modal/Modal";
import auth from "../../../reducers/auth";
import { BRAND_NAME } from "../../../brand";

export function Verified(props) {

    const [isLoading, setIsLoading] = useState(true);
    const status = useSelector(state => state.auth.status);
    const failureMsg = useSelector(state => state.messages.activateFail);

    // when the component mounts, Grab information from URL and send to back-end to activate account or verify email
    useEffect(() => {
        // if a user was previously logged in, prevent loaduser and instead logout
        // once confirmed logged out, activate account
        localStorage.setItem("verification_ongoing", true);
    }, [])

    const activationHasRun = useRef(false);

    useEffect(() => {
        if (!activationHasRun.current) {
            if (!status) {
                activationHasRun.current = true;
                props.activateAccount(props.match.params.uidb64, props.match.params.token);
            }
        }
        (status && status !== "authError") &&
        setIsLoading(false);
    }, [status]);


    switch(status) {
    case "activated":
        return (
            <Modal >
                {!isLoading &&
                <div className="text-center" >
                    <p className="content1 heavy gap-below-m" >Congratulations, your account has been activated.</p>
                    <p className="content1 light-black multiline gap-below-l" >You can now take advantage of our account benefits to enhance your project experience.</p>
                    <Link to="/login" id="login" className="link1" >Proceed to Login</Link>
                </div>}
            </Modal>
        )
    case "verified":
        return (
            <Modal  >
                {!isLoading &&
                    <div className="text-center" >
                    <p className="content1 heavy gap-below-s" >Congratulations, your email address has been verified.</p>
                    <p className="content1 light-black multiline" >There is one more step. The company you registered with must approve your account. Once this happens, you will be notified by email and will be able to log in to {BRAND_NAME}.</p>
                </div>}
            </Modal>
        )
    case "activateFailed":
        return (
            <Modal >
                {!isLoading &&
                <div className="text-center" >
                    <p className="content1 heavy gap-above-m gap-below-l" >{failureMsg}</p>
                    {failureMsg === `Your activation link has expired. Please re-register in order to join the ${BRAND_NAME} community.` && <Link to="/register" id="register" className="link1" >Register</Link>}
                    {failureMsg === `Activation link is invalid. Please register in order to join the ${BRAND_NAME} community.` && <Link to="/register" id="register" className="link1" >Register</Link>}
                    {failureMsg === "Your activation link has expired" && <Link to="/login" id="login" className="link1" >Resend the link</Link>}
                </div>}
            </Modal>
        )
    case "authError":
    default:
        return <></>
    }
}

const mapStateToProps = () => ({});

export default connect(mapStateToProps, {activateAccount} )(Verified);

